import React from 'react';
import { useTranslation } from 'react-i18next';

const SimulationEmptyState = () => {
    const { t } = useTranslation();

    return (
        <div className="simulation-empty-state">
            <div className="simulation-empty-state-content">
                <span className="vismaicon vismaicon-calculator simulation-empty-state-icon"></span>
                <h3 className="simulation-empty-state-title">{t('priceSimulation.selectPackageToBegin')}</h3>
                <p className="simulation-empty-state-subtitle">{t('priceSimulation.selectPackagePromptSubtitle')}</p>
            </div>
        </div>
    );
};

export default SimulationEmptyState;
